import React from 'react';
import { Link } from 'react-router-dom';
import { mockContactInfo } from '../utils/mock';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = ({ openPopup }) => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-[#7C2D12] text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="mb-4">
                <img 
                  src="/logo-white.png" 
                  alt="Trademark Fashion Brand" 
                  className="h-16 w-auto"
                />
              </div>
              <p className="text-white/80 mb-4 leading-relaxed">
                Your trusted partner in trademark registration and brand protection. We provide comprehensive USPTO filing services to businesses nationwide, protecting what matters most—your brand identity.
              </p>
              <div className="space-y-2 text-white/80">
                <div className="flex items-center">
                  <Phone size={16} className="mr-2" />
                  <a href={`tel:${mockContactInfo.phone.replace(/\s/g, '')}`} className="hover:text-[#FED7AA] transition-colors">
                    {mockContactInfo.phone}
                  </a>
                </div>
                <div className="flex items-center">
                  <Mail size={16} className="mr-2" />
                  <a href={`mailto:${mockContactInfo.email}`} className="hover:text-[#FED7AA] transition-colors">
                    {mockContactInfo.email}
                  </a>
                </div>
                <div className="flex items-start">
                  <MapPin size={16} className="mr-2 mt-1 flex-shrink-0" />
                  <span>{mockContactInfo.address}</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-4 text-[#FED7AA]">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/"
                    onClick={scrollToTop}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('about')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('services')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    Services
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('process')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    Process
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('pricing')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    Pricing
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('faqs')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    FAQs
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('contact')}
                    className="text-white/80 hover:text-[#FED7AA] transition-colors"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-bold mb-4 text-[#FED7AA]">Our Services</h4>
              <ul className="space-y-2 text-white/80">
                <li>Trademark Search</li>
                <li>Trademark Filing</li>
                <li>Office Action Response</li>
                <li>Trademark Monitoring</li>
                <li>Brand Protection</li>
                <li>Trademark Renewals</li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-white/70 text-sm">
                © {currentYear} {mockContactInfo.businessName}. All rights reserved.
              </div>
              
              <div className="flex space-x-6 text-sm">
                <Link 
                  to="/privacy-policy"
                  className="text-white/70 hover:text-[#FED7AA] transition-colors"
                >
                  Privacy Policy
                </Link>
                <Link 
                  to="/terms-conditions"
                  className="text-white/70 hover:text-[#FED7AA] transition-colors"
                >
                  Terms & Conditions
                </Link>
              </div>
            </div>
            
            <div className="mt-6 text-center text-white/60 text-xs">
              <p>
                Disclaimer: {mockContactInfo.businessName} is not a law firm and does not provide legal advice. 
                Our services are limited to preparing and filing trademark applications with the USPTO. 
                For legal advice, please consult with a licensed attorney.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
